import { render, staticRenderFns } from "./MySessionsDesktop.vue?vue&type=template&id=045e98d7&scoped=true"
import script from "./MySessionsDesktop.vue?vue&type=script&lang=js"
export * from "./MySessionsDesktop.vue?vue&type=script&lang=js"
import style0 from "./MySessionsDesktop.vue?vue&type=style&index=0&id=045e98d7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "045e98d7",
  null
  
)

export default component.exports